import http from "@/api.js";

export default {
    data: () => ({
        resolutionapi: "/meetings/resolution/",
        resolutiondata: [],
        resolutioncurrent: "",
        resolution_ready: 0,
        resolution_caleol: "VT_CALEOL"
    }),
    props: {
        resolution: { type: [String, Object], },
    },
    computed: {
        pending_resolutions(){ return this.pending_votes.map(pv => pv.resolution); },
        queued_resolutions(){  return [...new Set(this.queued_votes.map(pv => pv.resolution))]; },
        canPreviousResolution(){ return this.resolutiondata.findIndex(e => e.uid == this.resolutioncurrent) > 0; },
        canNextResolution(){ return this.resolutiondata.findIndex(e => e.uid == this.resolutioncurrent) < this.resolutiondata.length - 1; },
        currentResolution(){
            if(!this.resolutioncurrent && this.resolutiondata.length > 0)
                this.resolutioncurrent = this.resolution?.uid || this.resolutiondata[0].uid;
            if(this.resolutioncurrent)
                return this.resolutiondata.find(e => e.uid == this.resolutioncurrent);
        },
        currentResolutionHasGraph(){
            return ["VT_CLASSIC", "VT_CUSTOM", "VT_MULTIPLE"].indexOf(this.currentResolution?.vote_type) > -1;
        },
        isStepSignature(){ return this.currentResolution?.uid == "signature"; },
    },
    methods: {
        caleol_get(choices, id){
            return this.caleol_list(choices).find(ch => ch.id == id)?.desc;
        },
        caleol_list(choices){
            let caleol_choice = choices.find(ch => !ch.id)?.caleol_choices;
            return caleol_choice.map(ch => ({id: ch[0], desc: ch[1], choice: ""}));
        },
        resolutionChoiceDefault(resolution, pp){
            if(resolution.vote_type == this.resolution_caleol)
                return {resolution: resolution.uid, participant: pp, choice_out: this.caleol_values(resolution.vote_choices)};
            return {resolution: resolution.uid, participant: pp, choice_out: ""};
        },
        resolutionCompleted(resolution){
            if(resolution.vote_type == 'VT_NONE')
                return "novote"
            if(this.queued_resolutions.find(r =>r == resolution.uid))
                return "queued";
            if(this.votedata.filter(v => v.resolution == resolution.uid).length == this.participantdata.as_voter)
                return "completed";
            return "incomplete";
        },
        resolutionUrl(group, uid, suffix){
            suffix = suffix || "";
            const url = "/api/"+group+this.resolutionapi;
            return uid ? url+uid+"/"+suffix : url+suffix;
        },
        loadResolutions(meeting, only_sign=false){
            if(!this.resolution_ready)
                this.resolution_ready = 1;
            let signdata = {uid: "signature", title: "Signature", vote_system: "Signature", vote_type: "VT_NONE"};
            if(only_sign){
                this.resolutiondata = [signdata];
                this.resolution_ready = 2;
                return;
            }else{
                http.get(this.resolutionUrl(this.group), {params: { meeting: meeting.uid }}).then(response => {
                    this.resolutiondata = response.data;
                    this.resolution_ready = 2;
                    if(this.resolution)
                        this.resolutioncurrent = this.resolution.uid;
                    if(meeting.sign_conf){
                        if(meeting.sign_conf == 'DIRECTLY')
                            this.resolutiondata.unshift(signdata);
                        else if(meeting.sign_conf == 'AFTERVOTE')
                            this.resolutiondata.push(signdata);
                    }
                });
            }
        },
        setCurrentResolution(uid){
            this.resolutioncurrent = uid;
        },
        setPreviousResolution(){
            let pos = this.resolutiondata.findIndex(e => e.uid == this.resolutioncurrent);
            if (pos > 0) this.resolutioncurrent = this.resolutiondata[pos-1].uid;
        },
        setNextResolution(){
            let pos = this.resolutiondata.findIndex(e => e.uid == this.resolutioncurrent);
            if (pos < this.resolutiondata.length - 1) this.resolutioncurrent = this.resolutiondata[pos+1].uid;
        },
    }
}
